import React from "react";
import BasicLinkButton from "../baseLinkButton/BasicLinkButton";
import PropTypes from "prop-types";

function EmailMembersLinkButton(props) {
  const { onClick } = props;

  return <BasicLinkButton text="Email Members" iconClassName="fa-envelope" onClick={onClick} />;
}

EmailMembersLinkButton.propTypes = {
  onClick: PropTypes.func,
};

export default EmailMembersLinkButton;
